<template>
    <el-dialog
        :visible="visible"
        :title="dialogTitle"
        width="760px"
        custom-class="rcv-dialog rcv-interview-dialog"
        :close-on-click-modal="false"
        append-to-body
        @update:visible="close"
        @closed="onClosed"
    >
        <div v-if="candidate" class="rcv-interview-body">

            <!-- Thông tin ứng viên tóm tắt -->
            <div class="rcv-interview-cand">
                <div class="rcv-interview-cand__avatar">
                    <i class="el-icon-user-solid"></i>
                </div>
                <div class="rcv-interview-cand__info">
                    <div class="rcv-interview-cand__head">
                        <span class="rcv-interview-cand__name">{{ candidate.name || "Chưa có tên" }}</span>
                        <span class="rcv-interview-cand__id">#{{ candidate.id }}</span>
                        <span class="rcv-interview-cand__round-badge" :class="`rcv-interview-cand__round-badge--v${round}`">
                            {{ round === 1 ? 'Phỏng vấn V1 (Teamlead)' : 'Phỏng vấn V2 (Teamlead)' }}
                        </span>
                    </div>
                    <div class="rcv-interview-cand__meta">
                        <span v-if="candidate.phone"><i class="el-icon-phone-outline"></i> {{ candidate.phone }}</span>
                        <span v-if="candidate.email"><i class="el-icon-message"></i> {{ candidate.email }}</span>
                        <span v-if="jobTitle(candidate)"><i class="el-icon-suitcase"></i> {{ jobTitle(candidate) }}</span>
                    </div>
                </div>
            </div>

            <!-- Form Đánh giá phỏng vấn -->
            <el-form
                ref="interviewFormRef"
                :model="form"
                :rules="rules"
                label-position="top"
                size="small"
                class="rcv-interview-form"
            >
                <!-- Lựa chọn Kết quả PV: Pass / Fail -->
                <el-form-item label="Kết quả phỏng vấn" prop="result" required>
                    <div class="rcv-result-cards" :class="{ 'rcv-result-cards--2cols': !isHrDepartment }">
                        <div
                            class="rcv-result-card rcv-result-card--pass"
                            :class="{ 'is-active': form.result === 'pass' }"
                            @click="setResult('pass')"
                        >
                            <div class="rcv-result-card__icon">
                                <i class="el-icon-circle-check"></i>
                            </div>
                            <div class="rcv-result-card__content">
                                <div class="rcv-result-card__title">ĐẠT (Pass)</div>
                                <div class="rcv-result-card__desc">
                                    {{ round === 1 ? 'Chuyển sang PV V2 hoặc Đào tạo' : 'Đạt phỏng vấn V2, chuyển sang Cần điền Offer (13)' }}
                                </div>
                            </div>
                            <div class="rcv-result-card__radio">
                                <i :class="form.result === 'pass' ? 'el-icon-success' : 'el-icon-circle-check'"></i>
                            </div>
                        </div>

                        <div
                            class="rcv-result-card rcv-result-card--fail"
                            :class="{ 'is-active': form.result === 'fail' }"
                            @click="setResult('fail')"
                        >
                            <div class="rcv-result-card__icon">
                                <i class="el-icon-circle-close"></i>
                            </div>
                            <div class="rcv-result-card__content">
                                <div class="rcv-result-card__title">KHÔNG ĐẠT (Fail)</div>
                                <div class="rcv-result-card__desc">Dừng hành trình &amp; Tự động gửi Mail Cảm ơn</div>
                            </div>
                            <div class="rcv-result-card__radio">
                                <i :class="form.result === 'fail' ? 'el-icon-error' : 'el-icon-circle-close'"></i>
                            </div>
                        </div>

                        <div
                            v-if="isHrDepartment"
                            class="rcv-result-card rcv-result-card--cancel"
                            :class="{ 'is-active': form.result === 'cancel' }"
                            @click="setResult('cancel')"
                        >
                            <div class="rcv-result-card__icon">
                                <i class="el-icon-circle-close"></i>
                            </div>
                            <div class="rcv-result-card__content">
                                <div class="rcv-result-card__title">HUỶ LỊCH PV</div>
                                <div class="rcv-result-card__desc">Ứng viên xin dời / không tham gia</div>
                            </div>
                            <div class="rcv-result-card__radio">
                                <i :class="form.result === 'cancel' ? 'el-icon-error' : 'el-icon-circle-close'"></i>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <!-- ================== TRƯỜNG HỢP: CANCEL (HUỶ LỊCH) ================== -->
                <transition name="el-fade-in-linear">
                    <div v-if="form.result === 'cancel'" class="rcv-cancel-section">
                        <el-form-item label="Lý do huỷ lịch phỏng vấn" prop="cancel_reason" required>
                            <el-input
                                v-model="form.cancel_reason"
                                type="textarea"
                                :rows="3"
                                placeholder="Nhập chi tiết lý do huỷ lịch phỏng vấn (VD: Ứng viên bận việc đột xuất xin dời lịch, Không liên lạc được với ứng viên, Ứng viên từ chối tham gia...)..."
                                maxlength="1000"
                                show-word-limit
                            />
                        </el-form-item>

                        <div class="rcv-cancel-notice">
                            <div class="rcv-cancel-notice__icon">
                                <i class="el-icon-info"></i>
                            </div>
                            <div class="rcv-cancel-notice__content">
                                <div class="rcv-cancel-notice__title">
                                    {{ round === 1 ? 'Chuyển trạng thái sang: Huỷ phỏng vấn V1' : 'Chuyển trạng thái sang: Huỷ phỏng vấn V2' }}
                                </div>
                                <div class="rcv-cancel-notice__desc">
                                    Lịch phỏng vấn sẽ được huỷ bỏ. Bạn có thể xếp lại lịch phỏng vấn cho ứng viên bất cứ lúc nào trong Chi tiết hồ sơ.
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- ================== TRƯỜNG HỢP: FAIL ================== -->
                <transition name="el-fade-in-linear">
                    <div v-if="form.result === 'fail'" class="rcv-fail-section">
                        <el-form-item label="Lý do không đạt (Fail)" prop="fail_reason" required>
                            <el-input
                                v-model="form.fail_reason"
                                type="textarea"
                                :rows="3"
                                placeholder="Nhập chi tiết lý do ứng viên không đạt (VD: Chưa đáp ứng kỹ năng giảng dạy, tác phong chưa phù hợp, kỳ vọng chưa khớp...)..."
                                maxlength="1000"
                                show-word-limit
                            />
                        </el-form-item>

                        <div class="rcv-email-notice">
                            <div class="rcv-email-notice__icon">
                                <i class="el-icon-message"></i>
                            </div>
                            <div class="rcv-email-notice__content">
                                <div class="rcv-email-notice__title">
                                    <el-checkbox v-model="form.send_thank_you_mail" disabled>
                                        Tự động gửi Mail Cảm ơn &amp; Dừng hành trình
                                    </el-checkbox>
                                </div>
                                <div class="rcv-email-notice__sub">
                                    Hệ thống sẽ tự động gửi Email cảm ơn và thông báo kết quả phỏng vấn tới hộp thư
                                    <b v-if="candidate.email">{{ candidate.email }}</b>
                                    <span v-else class="text-danger">(Chưa có email)</span>, đồng thời kết thúc tiến trình ứng tuyển của ứng viên này.
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- ================== TRƯỜNG HỢP: PASS ================== -->
                <!-- ================== TRƯỜNG HỢP: PASS ================== -->
                <transition name="el-fade-in-linear">
                    <div v-if="form.result === 'pass'" class="rcv-pass-section">
                        <!-- THÔNG TIN CHO VÒNG 1 (TEAMLEAD) -->
                        <template v-if="round === 1">
                            <div class="rcv-feedback-section mb-3">
                                <div class="rcv-feedback-header">
                                    <div class="rcv-feedback-header__title">
                                        <i class="el-icon-chat-dot-round text-primary mr-1"></i>
                                        <span>Nhận xét kết quả PV V1 của Teamlead</span>
                                    </div>
                                    <div class="rcv-feedback-header__actions">
                                        <el-button
                                            size="mini"
                                            type="primary"
                                            plain
                                            icon="el-icon-magic-stick"
                                            @click="fillFeedbackTemplate"
                                        >
                                            Điền mẫu gợi ý
                                        </el-button>
                                        <el-button
                                            v-if="form.team_lead_feedback"
                                            size="mini"
                                            type="text"
                                            class="text-danger ml-2"
                                            icon="el-icon-delete"
                                            @click="clearFeedbackTemplate"
                                        >
                                            Xoá nội dung
                                        </el-button>
                                    </div>
                                </div>

                                <div class="rcv-feedback-hint mb-2">
                                    <i class="el-icon-info text-primary mr-1"></i>
                                    <span>Bấm nút <b>"Điền mẫu gợi ý"</b> để tự động điền 4 nội dung đánh giá theo mẫu hoặc bạn có thể tự nhập &amp; chỉnh sửa nội dung bên dưới:</span>
                                </div>

                                <el-form-item prop="team_lead_feedback" class="mb-2">
                                    <el-input
                                        v-model="form.team_lead_feedback"
                                        type="textarea"
                                        :rows="6"
                                        placeholder="Nhập nhận xét kết quả PV V1 của Teamlead hoặc bấm 'Điền mẫu gợi ý' để tự động điền..."
                                        maxlength="2000"
                                        show-word-limit
                                    />
                                </el-form-item>

                                <div class="rcv-quick-tags">
                                    <span class="rcv-quick-tags__label">Gợi ý từ khóa:</span>
                                    <el-tag
                                        v-for="(tag, tIdx) in quickCustomTags"
                                        :key="tIdx"
                                        size="mini"
                                        class="rcv-quick-tag"
                                        @click="addFeedbackTag(tag)"
                                    >
                                        + {{ tag }}
                                    </el-tag>
                                </div>
                            </div>

                            <!-- Bước tiếp theo cho V1 -->
                            <el-form-item label="Chuyển sang bước tiếp theo" prop="next_step_v1" required>
                                <el-radio-group v-model="form.next_step_v1" class="rcv-next-step-group">
                                    <el-radio :label="9" border class="rcv-next-step-opt">
                                        <i class="el-icon-chat-line-square text-primary"></i>
                                        <b>Chuyển sang Phỏng vấn V2</b>
                                        <span class="rcv-next-step-desc">(Teamlead phỏng vấn vòng 2)</span>
                                    </el-radio>
                                    <el-radio :label="16" border class="rcv-next-step-opt">
                                        <i class="el-icon-reading text-success"></i>
                                        <b>Chuyển sang Đào tạo</b>
                                        <span class="rcv-next-step-desc">(Gửi ứng viên vào Đào tạo hội nhập)</span>
                                    </el-radio>
                                    <el-radio :label="7" border class="rcv-next-step-opt">
                                        <i class="el-icon-check text-warning"></i>
                                        <b>Lưu kết quả Pass V1</b>
                                        <span class="rcv-next-step-desc">(Chỉ lưu kết quả Đạt phỏng vấn V1)</span>
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <!-- Khối xếp lịch Phỏng vấn Vòng 2 khi chọn Chuyển sang PV V2 (Tuỳ chọn) -->
                            <transition name="el-fade-in-linear">
                                <div v-if="form.next_step_v1 === 9" class="rcv-schedule-v2-box">
                                    <div class="rcv-schedule-v2-header">
                                        <div class="rcv-schedule-v2-header__left">
                                            <i class="el-icon-date text-primary"></i>
                                            <span class="rcv-schedule-v2-title">Thời gian phỏng vấn Vòng 2</span>
                                            <span class="rcv-schedule-v2-badge rcv-schedule-v2-badge--optional">Tuỳ chọn</span>
                                        </div>
                                        <div class="rcv-schedule-v2-header__right">
                                            <el-button
                                                v-if="!form.schedule_v2.date && !form.schedule_v2.start_time"
                                                size="mini"
                                                type="text"
                                                icon="el-icon-magic-stick"
                                                @click="fillDefaultScheduleV2"
                                            >
                                                + Gợi ý ngày giờ
                                            </el-button>
                                            <el-button
                                                v-else
                                                size="mini"
                                                type="text"
                                                class="text-danger"
                                                icon="el-icon-delete"
                                                @click="clearScheduleV2Fields"
                                            >
                                                Xoá lịch đã chọn
                                            </el-button>
                                        </div>
                                    </div>
                                    <div class="rcv-schedule-v2-hint" style="font-size: 12px; line-height: 1.4; padding: 6px 10px; background: #f8fafc; border-radius: 6px; margin-bottom: 12px; border-left: 3px solid #3b82f6;">
                                        <span v-if="form.schedule_v2.date && form.schedule_v2.start_time" class="text-success font-medium">
                                            <i class="el-icon-check"></i> Đã chọn thời gian: Hồ sơ sẽ chuyển sang <b>Phỏng vấn V2 (#9)</b>.
                                        </span>
                                        <span v-else class="text-secondary">
                                            <i class="el-icon-info"></i> Để trống ngày/giờ: Trạng thái sẽ lưu là <b>Đã nhập kết quả PV V1 - Pass (#7)</b>. Sau này khi xếp lịch mới chuyển sang <b>Phỏng vấn V2 (#9)</b>.
                                        </span>
                                    </div>
                                    <!-- Ngày phỏng vấn (date) - tuỳ chọn -->
                                    <el-form-item label="Ngày phỏng vấn V2 (Tuỳ chọn)" prop="schedule_v2.date">
                                        <el-date-picker
                                            v-model="form.schedule_v2.date"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            format="dd/MM/yyyy"
                                            placeholder="Chọn ngày phỏng vấn V2 (để trống nếu chưa xếp lịch)"
                                            :picker-options="interviewDatePickerOptions"
                                            clearable
                                            class="w-100"
                                        />
                                    </el-form-item>

                                    <!-- Khung giờ bắt đầu & kết thúc (start_time, end_time) - tuỳ chọn -->
                                    <div class="rcv-form-row">
                                        <el-form-item label="Giờ bắt đầu (Tuỳ chọn)" prop="schedule_v2.start_time" class="rcv-form-col">
                                            <el-time-select
                                                v-model="form.schedule_v2.start_time"
                                                :picker-options="interviewTimePickerOptions"
                                                placeholder="Bắt đầu"
                                                clearable
                                                class="w-100"
                                                @change="onScheduleV2StartTimeChange"
                                            />
                                        </el-form-item>

                                        <el-form-item label="Giờ kết thúc (Tuỳ chọn)" prop="schedule_v2.end_time" class="rcv-form-col">
                                            <el-time-select
                                                v-model="form.schedule_v2.end_time"
                                                :picker-options="{
                                                    ...interviewTimePickerOptions,
                                                    minTime: form.schedule_v2.start_time,
                                                }"
                                                placeholder="Kết thúc"
                                                clearable
                                                class="w-100"
                                            />
                                        </el-form-item>
                                    </div>
                                </div>
                            </transition>
                        </template>

                        <!-- THÔNG TIN CHO VÒNG 2 (TEAMLEAD) -->
                        <template v-else>
                            <el-form-item label="Nhận xét chi tiết của Teamlead">
                                <el-input
                                    v-model="form.note"
                                    type="textarea"
                                    :rows="3"
                                    placeholder="Nhập nhận xét về mức độ phù hợp, kỹ năng, nguyện vọng của ứng viên..."
                                    maxlength="1000"
                                    show-word-limit
                                />
                            </el-form-item>

                            <!-- Bước tiếp theo cho V2: Cố định chuyển sang Cần điền Offer (13) -->
                            <el-form-item label="Chuyển sang bước tiếp theo">
                                <div class="rcv-next-step-fixed">
                                    <div class="rcv-next-step-fixed__icon">
                                        <i class="el-icon-document text-primary"></i>
                                    </div>
                                    <div class="rcv-next-step-fixed__content">
                                        <div class="rcv-next-step-fixed__title">
                                            Cần điền Offer
                                        </div>
                                        <div class="rcv-next-step-fixed__desc">
                                            Ứng viên đạt Phỏng vấn Vòng 2 sẽ tự động chuyển sang tiến trình <b>Cần điền Offer</b> để HR điền thông tin Mức lương đề xuất và Ngày bắt đầu làm việc.
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </template>
                    </div>
                </transition>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">Đóng</el-button>
            <el-button
                size="small"
                :type="form.result === 'cancel' || form.result === 'fail' ? 'danger' : 'primary'"
                :loading="submitting"
                :disabled="form.result === 'cancel' && !isHrDepartment"
                :icon="form.result === 'cancel' ? 'el-icon-circle-close' : (form.result === 'fail' ? 'el-icon-close' : 'el-icon-check')"
                @click="submit"
            >
                {{ form.result === 'cancel' ? 'Xác nhận huỷ lịch phỏng vấn' : (form.result === 'fail' ? 'Xác nhận kết quả Không đạt' : 'Lưu kết quả phỏng vấn') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import moment from "moment-timezone";
import {
    PHONG_VAN_V1,
    HUY_PHONG_VAN_V1,
    PHONG_VAN_V2,
    HUY_PHONG_VAN_V2,
    DA_NHAP_KET_QUA_PHONG_VAN_V1_PASS,
    DA_NHAP_KET_QUA_PHONG_VAN_V1_FAIL,
    DA_NHAP_KET_QUA_PHONG_VAN_V2_PASS,
    DA_NHAP_KET_QUA_PHONG_VAN_V2_FAIL,
    CAN_DIEN_OFFER,
    CAN_LAM_THU_TUC_PASS,
    DA_GUI_DAO_TAO_HOI_NHAP,
} from "@/core/config/recruitmentCvs/recruitmentCvsOption";

/** "08:00:00" | "08:00" -> "08:00" */
function toHm(value) {
    const m = value ? String(value).match(/^(\d{1,2}):(\d{2})/) : null;
    return m ? `${m[1].padStart(2, "0")}:${m[2]}` : "";
}

/** "08:00" -> "08:00:00" (định dạng backend yêu cầu) */
function toHms(value) {
    const hm = toHm(value);
    return hm ? `${hm}:00` : null;
}

const DEFAULT_V1_FEEDBACK_TEMPLATE = [
    "1. Năng lực chuyên môn & Kỹ năng nghiệp vụ: Kiến thức nghiệp vụ, kinh nghiệm làm việc và khả năng ứng dụng thực tế - Đạt",
    "2. Kỹ năng mềm & Giải quyết vấn đề: Giao tiếp, làm việc nhóm, quản lý thời gian và giải quyết vấn đề - Tốt",
    "3. Thái độ & Tố chất cá nhân: Sự chủ động, tinh thần cầu tiến, khả năng gắn bó và độ thích nghi - Tốt",
    "4. Sự phù hợp văn hóa doanh nghiệp: Mức độ hòa nhập với giá trị cốt lõi và môi trường làm việc của công ty - Phù hợp",
].join("\n");

const QUICK_CUSTOM_TAGS = [
    "Chuyên môn tốt, phát âm chuẩn",
    "Giao tiếp tự tin, năng lượng",
    "Thái độ cầu tiến, chủ động",
    "Phù hợp văn hóa công ty",
    "Kinh nghiệm giảng dạy thực tế phong phú",
    "Tiềm năng phát triển tốt",
];

export default {
    name: "InterviewEvaluationDialog",
    props: {
        visible: { type: Boolean, default: false },
        candidate: { type: Object, default: null },
        orders: { type: Array, default: () => [] },
        round: { type: Number, default: 1 }, // 1 = PV V1 (Teamlead), 2 = PV V2 (Teamlead)
        isHrDepartment: { type: Boolean, default: true },
        currentUserName: { type: String, default: "" },
        submitting: { type: Boolean, default: false },
    },
    data() {
        return {
            quickCustomTags: QUICK_CUSTOM_TAGS,
            form: {
                result: "pass", // 'pass' | 'fail' | 'cancel'
                cancel_reason: "",
                fail_reason: "",
                send_thank_you_mail: true,
                score: 8.0,
                criteria: {
                    expertise: 4,
                    communication: 4,
                    attitude: 5,
                    potential: 4,
                    culture_fit: 4,
                    commitment: 4,
                },
                team_lead_feedback: "",
                note: "",
                next_step_v1: 9, // default sang PV V2 (9) hoặc Đào tạo (16)
                next_step_v2: 13, // default sang Cần điền Offer (13)
                schedule_v2: {
                    round: 2,
                    date: "",
                    start_time: "14:00",
                    end_time: "15:00",
                },
            },
            interviewDatePickerOptions: {
                firstDayOfWeek: 1,
            },
            interviewTimePickerOptions: {
                start: "07:00",
                step: "00:15",
                end: "22:00",
            },
            rules: {
                result: [{ required: true, message: "Vui lòng chọn kết quả phỏng vấn", trigger: "change" }],
                fail_reason: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.result === "fail" && !value) {
                                callback(new Error("Vui lòng nhập lý do không đạt"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                cancel_reason: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.result === "cancel" && !value) {
                                callback(new Error("Vui lòng nhập lý do huỷ lịch phỏng vấn"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                team_lead_feedback: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.round === 1 && this.form.result === "pass" && (!value || !value.trim())) {
                                callback(new Error("Vui lòng nhập nhận xét kết quả PV V1 hoặc bấm 'Điền mẫu gợi ý'"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                "schedule_v2.round": [],
                "schedule_v2.date": [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.schedule_v2.start_time && !value) {
                                callback(new Error("Vui lòng chọn ngày phỏng vấn nếu đã chọn giờ bắt đầu"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
                "schedule_v2.start_time": [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.schedule_v2.date && !value) {
                                callback(new Error("Vui lòng chọn giờ bắt đầu nếu đã chọn ngày phỏng vấn"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
                "schedule_v2.end_time": [
                    {
                        validator: (rule, value, callback) => {
                            const start = this.form.schedule_v2.start_time;
                            if (start && value && value <= start) {
                                callback(new Error("Giờ kết thúc phải sau giờ bắt đầu"));
                                return;
                            }
                            callback();
                        },
                        trigger: "change",
                    },
                ],
            },
        };
    },
    computed: {
        dialogTitle() {
            if (this.round === 2) {
                return "Điền kết quả Phỏng vấn Vòng 2 (Teamlead)";
            }
            return "Điền kết quả Phỏng vấn Vòng 1 (Teamlead)";
        },
        hasScheduleV2Input() {
            return Boolean(this.form.schedule_v2.date && this.form.schedule_v2.start_time);
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.initFormData();
            }
        },
        candidate() {
            if (this.visible) {
                this.initFormData();
            }
        },
        "form.next_step_v1"() {
            this.$nextTick(() => {
                if (this.$refs.interviewFormRef) {
                    this.$refs.interviewFormRef.clearValidate([
                        "schedule_v2.round",
                        "schedule_v2.date",
                        "schedule_v2.start_time",
                        "schedule_v2.end_time",
                    ]);
                }
            });
        },
        "form.result"() {
            this.$nextTick(() => {
                if (this.$refs.interviewFormRef) {
                    this.$refs.interviewFormRef.clearValidate();
                }
            });
        },
    },
    methods: {
        formatMoney(num) {
            if (num === null || num === undefined || num === "") return "0";
            return Number(num).toLocaleString("vi-VN");
        },
        jobTitle(c) {
            if (!c) return "";
            const found = this.orders.find((o) =>
                String(o.id) === String(c.job_id) ||
                String(o.id) === String(c.order_id) ||
                String(o.id) === String(c.raw_job_id) ||
                (o.recruitment_job_id && String(o.recruitment_job_id) === String(c.job_id)) ||
                (o.recruitment_job_id && String(o.recruitment_job_id) === String(c.raw_job_id))
            );
            return found ? (found.title || found.position_title || "") : (c.order_title || "");
        },
        setResult(res) {
            if (res === "cancel" && !this.isHrDepartment) {
                this.$message.warning("Chỉ HR mới có quyền huỷ lịch phỏng vấn");
                return;
            }
            this.form.result = res;
            if (this.$refs.interviewFormRef) {
                this.$refs.interviewFormRef.clearValidate();
            }
        },
        fillDefaultScheduleV2() {
            this.form.schedule_v2.round = 2;
            this.form.schedule_v2.date = moment().add(1, "days").format("YYYY-MM-DD");
            this.form.schedule_v2.start_time = "14:00";
            this.form.schedule_v2.end_time = "15:00";
            this.$nextTick(() => {
                if (this.$refs.interviewFormRef) {
                    this.$refs.interviewFormRef.clearValidate([
                        "schedule_v2.round",
                        "schedule_v2.date",
                        "schedule_v2.start_time",
                        "schedule_v2.end_time",
                    ]);
                }
            });
        },
        clearScheduleV2Fields() {
            this.form.schedule_v2.date = "";
            this.form.schedule_v2.start_time = "";
            this.form.schedule_v2.end_time = "";
            this.$nextTick(() => {
                if (this.$refs.interviewFormRef) {
                    this.$refs.interviewFormRef.clearValidate([
                        "schedule_v2.round",
                        "schedule_v2.date",
                        "schedule_v2.start_time",
                        "schedule_v2.end_time",
                    ]);
                }
            });
        },
        onScheduleV2StartTimeChange(val) {
            if (!val) return;
            const match = String(val).match(/^(\d{1,2}):(\d{2})/);
            if (!match) return;
            let hour = parseInt(match[1], 10);
            let min = parseInt(match[2], 10);
            hour += 1;
            if (hour > 23) {
                hour = 23;
                min = 59;
            }
            const endHourStr = String(hour).padStart(2, "0");
            const endMinStr = String(min).padStart(2, "0");
            this.form.schedule_v2.end_time = `${endHourStr}:${endMinStr}`;
        },
        fillFeedbackTemplate() {
            if (this.form.team_lead_feedback && this.form.team_lead_feedback.trim()) {
                this.$confirm(
                    "Nội dung nhận xét hiện tại sẽ được thay thế bằng mẫu gợi ý 4 tiêu chí. Bạn có muốn tiếp tục?",
                    "Xác nhận điền mẫu gợi ý",
                    {
                        confirmButtonText: "Đồng ý",
                        cancelButtonText: "Huỷ",
                        type: "info",
                    }
                ).then(() => {
                    this.form.team_lead_feedback = DEFAULT_V1_FEEDBACK_TEMPLATE;
                    this.$message.success("Đã điền mẫu gợi ý thành công");
                }).catch(() => {});
            } else {
                this.form.team_lead_feedback = DEFAULT_V1_FEEDBACK_TEMPLATE;
                this.$message.success("Đã điền mẫu gợi ý thành công");
            }
        },
        clearFeedbackTemplate() {
            this.form.team_lead_feedback = "";
        },
        addFeedbackTag(tag) {
            if (!this.form.team_lead_feedback) {
                this.form.team_lead_feedback = tag;
            } else if (!this.form.team_lead_feedback.includes(tag)) {
                this.form.team_lead_feedback = `${this.form.team_lead_feedback}\n- ${tag}`;
            }
        },
        initFormData() {
            const cand = this.candidate || {};
            const existingDate = cand.interview_v2_date || cand.v2_date || "";
            const existingStart = toHm(cand.interview_v2_start_time || cand.v2_start_time) || "";
            const existingEnd = toHm(cand.interview_v2_end_time || cand.v2_end_time) || "";

            const existingRaw = (cand.team_lead_feedback || cand.interview_v1_note || cand.result_note || "").trim();

            this.form = {
                result: "pass",
                cancel_reason: "",
                fail_reason: "",
                send_thank_you_mail: true,
                score: 8.0,
                criteria: {
                    expertise: 4,
                    communication: 4,
                    attitude: 5,
                    potential: 4,
                    culture_fit: 4,
                    commitment: 4,
                },
                team_lead_feedback: existingRaw,
                note: existingRaw,
                next_step_v1: 9,
                next_step_v2: 13,
                schedule_v2: {
                    round: 2,
                    date: existingDate,
                    start_time: existingStart,
                    end_time: existingEnd,
                },
            };
            this.$nextTick(() => {
                if (this.$refs.interviewFormRef) {
                    this.$refs.interviewFormRef.clearValidate();
                }
            });
        },
        submit() {
            if (this.form.result === "cancel" && !this.isHrDepartment) {
                this.$message.warning("Chỉ HR mới có quyền huỷ lịch phỏng vấn");
                return;
            }

            this.$refs.interviewFormRef.validate((valid) => {
                if (!valid) return;

                const isPass = this.form.result === "pass";
                const isCancel = this.form.result === "cancel";
                let targetStatus;

                if (isCancel) {
                    targetStatus = this.round === 1 ? HUY_PHONG_VAN_V1 : HUY_PHONG_VAN_V2;
                } else if (!isPass) {
                    // FAIL: Dừng hành trình
                    targetStatus = this.round === 1
                        ? DA_NHAP_KET_QUA_PHONG_VAN_V1_FAIL // 8
                        : DA_NHAP_KET_QUA_PHONG_VAN_V2_FAIL; // 12
                } else {
                    // PASS: Lấy bước tiếp theo
                    if (this.round === 1) {
                        const s2 = this.form.schedule_v2 || {};
                        const hasScheduleV2Input = Boolean(
                            Number(this.form.next_step_v1) === 9 && s2.date && s2.start_time
                        );

                        if (Number(this.form.next_step_v1) === 16) {
                            targetStatus = 16; // Chuyển sang Đào tạo
                        } else if (hasScheduleV2Input) {
                            // Khi có nhập thời gian PV V2 (có date và start_time) mới chuyển sang Phỏng vấn V2 (9)
                            targetStatus = PHONG_VAN_V2; // 9
                        } else {
                            // Mới nhập kết quả lần 1 (chưa nhập thời gian PV V2): lưu trạng thái Đã nhập kết quả PV V1 - Pass (7)
                            targetStatus = DA_NHAP_KET_QUA_PHONG_VAN_V1_PASS; // 7
                        }
                    } else {
                        // Vòng 2 Pass: Điền kết quả PV V2 pass thì update status = CAN_DIEN_OFFER = 13
                        targetStatus = CAN_DIEN_OFFER; // 13
                    }
                }

                const isScheduleV2 = this.round === 1 && isPass && Number(targetStatus) === PHONG_VAN_V2;
                const s2 = this.form.schedule_v2 || {};
                const hasScheduleV2 = Boolean(isScheduleV2 && s2.date && s2.start_time);

                if (hasScheduleV2 && s2.end_time && s2.end_time <= s2.start_time) {
                    this.$message.warning("Giờ kết thúc phỏng vấn Vòng 2 phải sau giờ bắt đầu");
                    return;
                }

                const s2Date = hasScheduleV2 ? s2.date : null;
                const s2StartTime = hasScheduleV2 ? toHms(s2.start_time) : null;
                const s2EndTime = hasScheduleV2 && s2.end_time ? toHms(s2.end_time) : null;
                const s2Round = 2;

                let compiledFeedback = "";
                if (isPass && this.round === 1) {
                    compiledFeedback = (this.form.team_lead_feedback || "").trim();
                    if (!compiledFeedback) {
                        this.$message.warning("Vui lòng nhập nhận xét kết quả PV V1 của Teamlead hoặc bấm 'Điền mẫu gợi ý'");
                        return;
                    }
                    this.form.note = compiledFeedback;
                }

                const roundName = this.round === 1 ? "PV V1 (Teamlead)" : "PV V2 (Teamlead)";
                let resultText = "ĐẠT (Pass)";
                if (isCancel) {
                    resultText = "HUỶ LỊCH PHỎNG VẤN";
                } else if (!isPass) {
                    resultText = "KHÔNG ĐẠT (Fail)";
                } else if (this.round === 2) {
                    resultText = "ĐẠT (Pass) - Chuyển Cần điền Offer (13)";
                }
                
                let noteContent = `[Kết quả ${roundName} - ${resultText}]`;
                if (isCancel) {
                    noteContent += `\nLý do huỷ lịch: ${this.form.cancel_reason}`;
                } else if (!isPass) {
                    noteContent += `\nLý do Fail: ${this.form.fail_reason}`;
                    if (this.form.send_thank_you_mail) {
                        noteContent += `\n(Đã gửi Mail Cảm ơn & Dừng hành trình)`;
                    }
                } else {
                    if (this.round === 1) {
                        if (compiledFeedback) {
                            noteContent += `\nĐánh giá Teamlead:\n${compiledFeedback}`;
                        }
                    } else if (this.form.note) {
                        noteContent += `\nNhận xét: ${this.form.note}`;
                    }
                    if (isScheduleV2 && hasScheduleV2 && s2Date && s2.start_time) {
                        noteContent += `\nLịch PV Vòng 2: Ngày ${moment(s2Date).format("DD/MM/YYYY")} từ ${s2.start_time}${s2.end_time ? " đến " + s2.end_time : ""}`;
                    }
                }

                const finalV1Note = isPass ? compiledFeedback : this.form.fail_reason;
                const updatedCandidate = {
                    ...this.candidate,
                    status: targetStatus,
                    ...(isCancel ? {
                        cancel_reason: this.form.cancel_reason,
                        ...(this.round === 1
                            ? { cancel_interview_v1_reason: this.form.cancel_reason }
                            : { cancel_interview_v2_reason: this.form.cancel_reason }),
                    } : (this.round === 1 ? {
                        interview_v1_result: this.form.result,
                        interview_v1_note: finalV1Note,
                        team_lead_feedback: isPass ? compiledFeedback : undefined,
                        result_note: finalV1Note,
                        ...(isScheduleV2 ? {
                            round: s2Round,
                            ...(hasScheduleV2 ? {
                                date: s2Date,
                                start_time: s2StartTime,
                                end_time: s2EndTime,
                                interview_v2_date: s2Date,
                                interview_v2_start_time: s2StartTime,
                                interview_v2_end_time: s2EndTime,
                            } : {}),
                        } : {}),
                    } : {
                        interview_v2_result: this.form.result,
                        interview_v2_note: isPass ? this.form.note : this.form.fail_reason,
                        result_note: isPass ? this.form.note : this.form.fail_reason,
                    })),
                };

                this.$emit("submit", {
                    id: this.candidate.id,
                    status: targetStatus,
                    round: isScheduleV2 ? s2Round : this.round,
                    result: this.form.result,
                    cancel_reason: isCancel ? this.form.cancel_reason : undefined,
                    reason: isCancel ? this.form.cancel_reason : undefined,
                    send_thank_you_mail: !isPass && !isCancel && this.form.send_thank_you_mail,
                    note: noteContent,
                    team_lead_feedback: isPass && this.round === 1 ? compiledFeedback : undefined,
                    interview_v1_note: this.round === 1 ? finalV1Note : undefined,
                    result_note: this.round === 1 ? finalV1Note : (isPass ? this.form.note : this.form.fail_reason),
                    ...(isScheduleV2 ? {
                        round: s2Round,
                        ...(hasScheduleV2 ? {
                            date: s2Date,
                            start_time: s2StartTime,
                            end_time: s2EndTime,
                            schedule_v2: {
                                round: s2Round,
                                date: s2Date,
                                start_time: s2StartTime,
                                end_time: s2EndTime,
                            },
                        } : {}),
                    } : {}),
                    interview_data: isCancel ? null : {
                        round: this.round,
                        result: this.form.result,
                        fail_reason: !isPass ? this.form.fail_reason : "",
                        note: isPass && this.round === 1 ? compiledFeedback : this.form.note,
                        team_lead_feedback: isPass && this.round === 1 ? compiledFeedback : undefined,
                        evaluated_by: this.currentUserName,
                        evaluated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
                        ...(isScheduleV2 ? {
                            next_round: s2Round,
                            ...(hasScheduleV2 ? {
                                v2_date: s2Date,
                                v2_start_time: s2StartTime,
                                v2_end_time: s2EndTime,
                            } : {}),
                        } : {}),
                    },
                    candidate: updatedCandidate,
                });
            });
        },
        cancelInterview() {
            if (!this.candidate) return;
            if (!this.isHrDepartment) {
                this.$message.warning("Chỉ HR mới có quyền huỷ lịch phỏng vấn");
                return;
            }
            const roundName = this.round === 2 ? "Vòng 2" : "Vòng 1";
            const candidateName = this.candidate.name || `#${this.candidate.id}`;

            this.$prompt(
                `Nhập lý do huỷ lịch tham gia phỏng vấn ${roundName} của ứng viên "${candidateName}":`,
                `Xác nhận huỷ lịch tham gia phỏng vấn ${roundName}`,
                {
                    confirmButtonText: "Xác nhận huỷ lịch",
                    cancelButtonText: "Đóng",
                    inputType: "textarea",
                    inputPlaceholder: "VD: Ứng viên bận việc đột xuất xin dời, Không liên lạc được, Ứng viên từ chối tham gia...",
                    inputPattern: /\S+/,
                    inputErrorMessage: "Vui lòng nhập lý do huỷ lịch phỏng vấn",
                    confirmButtonClass: "el-button--danger",
                }
            )
                .then(({ value }) => {
                    const reason = (value || "").trim();
                    this.$emit("cancel-interview", {
                        candidate: this.candidate,
                        round: this.round,
                        reason: reason,
                    });
                })
                .catch(() => {});
        },
        close() {
            this.$emit("update:visible", false);
        },
        onClosed() {
            this.initFormData();
        },
    },
};
</script>

<style scoped>
.rcv-interview-cand {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 18px;
}
.rcv-interview-cand__avatar {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: #e0e7ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}
.rcv-interview-cand__info {
    flex: 1;
    min-width: 0;
}
.rcv-interview-cand__head {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 4px;
}
.rcv-interview-cand__name {
    font-size: 16px;
    font-weight: 800;
    color: #1e293b;
}
.rcv-interview-cand__id {
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
}
.rcv-interview-cand__round-badge {
    font-size: 11.5px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 6px;
}
.rcv-interview-cand__round-badge--v1 {
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
}
.rcv-interview-cand__round-badge--v2 {
    background: #f3e8ff;
    color: #7c3aed;
    border: 1px solid #ddd6fe;
}
.rcv-interview-cand__meta {
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 12px;
    color: #64748b;
    flex-wrap: wrap;
}
.rcv-interview-cand__meta span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

/* Result Cards Selection */
.rcv-result-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}
.rcv-result-cards--2cols {
    grid-template-columns: repeat(2, 1fr);
}
.rcv-result-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    border-radius: 10px;
    border: 2px solid #e2e8f0;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
}
.rcv-result-card:hover {
    border-color: #cbd5e1;
    transform: translateY(-1px);
}
.rcv-result-card__icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}
.rcv-result-card--pass .rcv-result-card__icon {
    background: #d1fae5;
    color: #059669;
}
.rcv-result-card--fail .rcv-result-card__icon {
    background: #fee2e2;
    color: #dc2626;
}
.rcv-result-card--cancel .rcv-result-card__icon {
    background: #f1f5f9;
    color: #64748b;
}
.rcv-result-card__content {
    flex: 1;
}
.rcv-result-card__title {
    font-size: 14px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 3px;
}
.rcv-result-card--pass .rcv-result-card__title {
    color: #059669;
}
.rcv-result-card--fail .rcv-result-card__title {
    color: #dc2626;
}
.rcv-result-card--cancel .rcv-result-card__title {
    color: #475569;
}
.rcv-result-card__desc {
    font-size: 11.5px;
    color: #64748b;
    line-height: 1.3;
}
.rcv-result-card__radio {
    font-size: 18px;
    color: #cbd5e1;
}
/* Active states */
.rcv-result-card--pass.is-active {
    border-color: #059669;
    background: #f0fdf4;
}
.rcv-result-card--pass.is-active .rcv-result-card__radio {
    color: #059669;
}
.rcv-result-card--fail.is-active {
    border-color: #dc2626;
    background: #fef2f2;
}
.rcv-result-card--fail.is-active .rcv-result-card__radio {
    color: #dc2626;
}
.rcv-result-card--cancel.is-active {
    border-color: #64748b;
    background: #f8fafc;
}
.rcv-result-card--cancel.is-active .rcv-result-card__radio {
    color: #64748b;
}

.rcv-cancel-section {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 16px;
}
.rcv-cancel-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #fff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 12px 14px;
    margin-top: 10px;
}
.rcv-cancel-notice__icon {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-top: 1px;
}
.rcv-cancel-notice__title {
    font-weight: 700;
    font-size: 13px;
    color: #334155;
    margin-bottom: 2px;
}
.rcv-cancel-notice__desc {
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
}

/* Email Notice */
.rcv-email-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 8px;
    padding: 12px 14px;
    margin-top: 10px;
}
.rcv-email-notice__icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #fef3c7;
    color: #d97706;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
}
.rcv-email-notice__title {
    font-size: 13px;
    font-weight: 700;
    color: #92400e;
    margin-bottom: 2px;
}
.rcv-email-notice__sub {
    font-size: 12px;
    color: #b45309;
    line-height: 1.4;
}

/* Pass Section & Evaluation */
.rcv-eval-head {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 800;
    color: #1e293b;
    padding-bottom: 8px;
    margin-bottom: 12px;
    border-bottom: 1px solid #e2e8f0;
}
.rcv-eval-head i {
    color: #4f46e5;
    font-size: 16px;
}
.rcv-criteria-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 14px;
}
.rcv-criteria-item__label {
    font-size: 12.5px;
    font-weight: 700;
    color: #334155;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 5px;
}
.rcv-criteria-item__label i {
    color: #6366f1;
}

.rcv-form-row {
    display: flex;
    gap: 14px;
}
.rcv-form-col {
    flex: 1;
}
.rcv-form__hint {
    font-size: 11.5px;
    color: #059669;
    font-weight: 700;
    margin-top: 2px;
}

/* Next Step Group */
.rcv-next-step-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}
.rcv-next-step-opt {
    margin: 0 !important;
    padding: 8px 14px !important;
    height: auto !important;
    border-radius: 8px !important;
    display: flex !important;
    align-items: center !important;
}
.rcv-next-step-opt /deep/ .el-radio__label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
}
.rcv-next-step-desc {
    font-size: 11.5px;
    color: #64748b;
    font-weight: normal;
    margin-left: 4px;
}

/* Khối lịch phỏng vấn Vòng 2 */
.rcv-schedule-v2-box {
    background: #f0f7ff;
    border: 1px solid #bfdbfe;
    border-radius: 10px;
    padding: 14px 16px;
    margin-top: 12px;
    margin-bottom: 6px;
}
.rcv-schedule-v2-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #bfdbfe;
}
.rcv-schedule-v2-header__left {
    display: flex;
    align-items: center;
    gap: 8px;
}
.rcv-schedule-v2-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #1e3a8a;
}
.rcv-schedule-v2-badge {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 12px;
    background: #fee2e2;
    color: #dc2626;
    border: 1px solid #fecaca;
}
.rcv-schedule-v2-badge--optional {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

/* Khối cố định Cần điền Offer (13) */
.rcv-next-step-fixed {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f0f9ff;
    border: 1.5px solid #bae6fd;
    border-radius: 10px;
    padding: 12px 16px;
}
.rcv-next-step-fixed__icon {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    background: #e0f2fe;
    color: #0284c7;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}
.rcv-next-step-fixed__content {
    flex: 1;
    min-width: 0;
}
.rcv-next-step-fixed__title {
    font-size: 14px;
    font-weight: 700;
    color: #0369a1;
    margin-bottom: 2px;
}
.rcv-next-step-fixed__title span {
    font-size: 12px;
    font-weight: 600;
    color: #0284c7;
    margin-left: 4px;
}
.rcv-next-step-fixed__desc {
    font-size: 12px;
    color: #475569;
    line-height: 1.4;
}
.rcv-next-step-fixed__badge {
    flex-shrink: 0;
}

/* Feedback Section (V1) */
.rcv-feedback-section {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 16px;
}
.rcv-feedback-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
    flex-wrap: wrap;
}
.rcv-feedback-header__title {
    font-size: 13.5px;
    font-weight: 800;
    color: #1e293b;
    display: inline-flex;
    align-items: center;
}
.rcv-feedback-header__actions {
    display: flex;
    align-items: center;
}
.rcv-feedback-hint {
    font-size: 12px;
    color: #475569;
    line-height: 1.4;
    display: flex;
    align-items: flex-start;
}
.rcv-quick-tags {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}
.rcv-quick-tags__label {
    font-size: 11.5px;
    color: #64748b;
    font-weight: 600;
}
.rcv-quick-tag {
    cursor: pointer;
    transition: all 0.15s ease;
}
.rcv-quick-tag:hover {
    background: #eef2ff;
    color: #4f46e5;
    border-color: #c7d2fe;
}
</style>
